import SiteList from '@/views/site/list/SiteList'
import SiteForm from '@/views/site/form/SiteForm'
import SiteDomain from '@/views/site/list/components/SiteDomain'
import SitePassword from '@/views/site/list/components/SitePassword'
import SitePlugin from '@/views/site/list/components/SitePlugin'

const prefix = '/'

export const SitesRoutesPath = Object.freeze({
  LISTAR: {
    path: `${prefix}:id`,
    title: 'sites.list.title',
    name: 'siteList',
    component: SiteList,
    props: true
  },
  ADICIONAR: {
    path: `${prefix}:id/add-website`,
    title: 'sites.form.title',
    name: 'siteForm',
    component: SiteForm,
    props: true
  },
  domain: {
    path: `${prefix}:id/change-domain`,
    title: 'Alterar Domínio',
    name: 'siteDomain',
    component: SiteDomain,
    props: true
  },
  password: {
    path: `${prefix}:id/reset-password`,
    title: 'Alterar Senha',
    name: 'sitePassword',
    component: SitePassword,
    props: true
  },
  backup: {
    path: `${prefix}:id/backup-restore`,
    title: 'Backup e Restore',
    name: 'backup',
    component: SiteList,
    props: true
  },
  cdn: {
    path: `${prefix}:id/cdn`,
    title: 'CDN',
    name: 'cdn',
    component: SiteList,
    props: true
  },
  delete: {
    path: `${prefix}:id/delete-site`,
    title: 'Excluir Site',
    name: 'delete',
    component: SiteList,
    props: true
  },
  siteLimit: {
    path: `${prefix}:id/site-limit`,
    title: 'Você atingiu o limite de sites',
    name: 'siteLimit',
    component: SiteList,
    props: true
  },
  plugins: {
    path: `${prefix}:id/plugins`,
    title: 'Sugestão de Plugins',
    name: 'sitePlugin',
    component: SitePlugin,
    props: true
  }
})

export default Object.values(SitesRoutesPath)
